<template>
    <b-container fluid>
        <!-- User Interface controls -->
        <b-row>
            <b-col md="4" class="my-1 ml-0">
                <b-form-group v-if="(type === 'ft' || type === 'ne') && showMetrics !== false" class="ml-0 mb-0" label="ShowingMetricsFor:" label-cols-md="5">
                    <b-input-group size="sm" class="ml-0">
                        <b-form-select style="" v-model="metrics" id="sortBySelect">
                            <template v-slot:first>
                                <option value="today">Today</option>
                                <option value="thisweek">This Week</option>
                                <option value="thismonth">This Month</option>
                                <option value="last30" aria-selected="true">Last 30days</option>
                                <option value="last90">Last 90days</option>
                                <option value="thisyear">This Year</option>
                                <option value="alltime">All Time</option>
                                <option value="custom">Custom Period</option>
                            </template>
                        </b-form-select>

                    </b-input-group>
                </b-form-group>

            </b-col>
            <b-col sm="4">
                <b-form-group v-if="this.logs.ftMetrics.type === 'custom' && (type === 'ft' || type === 'ne') && showMetrics !== false" horizontal class="mb-0">
                    <b-input-group>
                        <div class="datepicker-trigger">
                            <input
                                    type="text"
                                    class="mt-1 p-1"
                                    id="datepicker-trigger"
                                    placeholder="Select dates"
                                    :value="formatDates(metricData.startDate, metricData.endDate)"
                            >

                            <AirbnbStyleDatepicker
                                    :trigger-element-id="'datepicker-trigger'"
                                    :mode="'range'"
                                    :fullscreen-mobile="true"
                                    :date-one="metricData.startDate"
                                    :date-two="metricData.endDate"
                                    @date-one-selected="val => { metricData.startDate = val }"
                                    @date-two-selected="val => { metricData.endDate = val }"
                            />
                        </div>
                        <b-input-group-append>
                            <b-btn size="xm" style="font-size: 11px; height: 87%;" class="pd-t-0 pd-b-0 mt-1" @click="queryFt()">Query</b-btn>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col md="4" class="my-1">
                <b-form-group
                        :label="showTitle?'Filter':''"
                        label-cols-sm="2"
                        label-align-sm="right"
                        label-size="sm"
                        label-for="filterInput"
                        class="mb-0"
                >
                    <b-input-group size="sm">
                        <b-form-input
                                v-model="filter"
                                type="search"
                                id="filterInput"
                                placeholder="Type to Search"
                        ></b-form-input>
                        <b-input-group-append>
                            <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>

        <br>

        <!-- Main table element -->
        <b-table
                small
                show-empty
                stacked="md"
                style="font-size: 12px;"
                striped
                :items="items"
                :busy="isBusy"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :filterIncludedFields="filterOn"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @filtered="onFiltered"
        >

            <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div>
            </template>

            <template v-slot:cell(serial)="row">
                {{ row.index + 1 }}
            </template>

            <template v-slot:cell(comment)="props">
                <span v-if="props.item.disputeCommentShow !== 'true'" >
                        {{props.item.disputeComment.substr(0,20)}}
                        <br>
                        <span style="cursor: pointer" autofocus @blur="props.item.disputeCommentShow = 'false'" title="view more">
                            <b-icon-three-dots
                                    @click="props.item.disputeCommentShow = 'true'"
                            >
                          </b-icon-three-dots>
                        </span>
                    </span>
                <span v-else>
                        {{props.item.disputeComment}}
                        <br>
                          <span style="cursor: pointer" autofocus @blur="props.item.disputeCommentShow = 'false'" title="view more">
                            <b-icon-backspace
                                    class="mr-2"
                                    title="VIEW LESS"
                                    @click="props.item.disputeCommentShow = 'false'"
                            >
                          </b-icon-backspace>
                        </span>
                    </span>
            </template>

            <template v-slot:cell(remark)="props">
                <span v-if="props.item.disputeRemarkShow !== 'true'" >
                        {{props.item.disputeRemark.substr(0,1).toUpperCase()+props.item.disputeRemark.substr(1,20).toLocaleLowerCase()}}
                         <br>
                        <span style="cursor: pointer" autofocus @blur="props.item.disputeRemarkShow = 'false'" title="view more">
                            <b-icon-three-dots
                                    @click="props.item.disputeRemarkShow = 'true'"
                            ></b-icon-three-dots>
                        </span>
                      </span>
                <span v-else>
                        {{props.item.disputeRemark.substr(0,1).toUpperCase()+props.item.disputeRemark.substr(1,props.item.disputeRemark.length).toLocaleLowerCase()}}
                          <br>
                          <span style="cursor: pointer" autofocus @blur="props.item.disputeRemarkShow = 'false'" title="view more">
                            <b-icon-backspace
                                    class="mr-2"
                                    title="VIEW LESS"
                                    @click="props.item.disputeRemarkShow = 'false'"
                            >
                          </b-icon-backspace>
                        </span>
                    </span>
            </template>

            <template v-slot:cell(actions)="row">
                <b-button size="xs" @click="row.toggleDetails">
                    {{ row.detailsShowing ? 'Less' : 'More' }}
                </b-button>
            </template>

            <template v-slot:cell(actionx)="row">
                <b-button size="xs" @click="navigate(row.item.officerID)">
                    Details
                </b-button>
            </template>

            <template v-slot:row-details="row">
                <b-card>
                    <ul>
                        <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                    </ul>
                </b-card>
            </template>
        </b-table>

        <b-row>
            <b-col md="3" class="my-1 ml-0">
                <b-form-group
                        :label="showTitle?'Per page':'Page'"
                        label-cols-sm="6"
                        label-cols-md="4"
                        label-cols-lg="3"
                        label-align-sm="right"
                        label-size="sm"
                        label-for="perPageSelect"
                        class="mb-0"
                >
                    <b-form-select
                            v-model="perPage"
                            id="perPageSelect"
                            size="sm"
                            :options="pageOptions"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="4"></b-col>
            <b-col sm="5" md="4" class="my-1 mr-0 mx-3">
                <b-pagination
                        v-model="currentPage"
                        :total-rows="items.length"
                        :per-page="perPage"
                        align="fill"
                        size="sm"
                        class="my-0"
                ></b-pagination>
            </b-col>
        </b-row>
<!--        <b-icon-arrow-up></b-icon-arrow-up>-->
        <!-- Info modal -->
<!--        <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">-->
<!--            <pre>{{ infoModal.content }}</pre>-->
<!--        </b-modal>-->
    </b-container>
</template>

<script>
    import {mapState} from "vuex";
    import format from 'date-fns/format'
    // import {MoreHorizontal, Delete} from 'vue-feather-icon'
    export default {
        props:['items', 'fields', 'isBusy','showTitle', 'type','showMetrics'],
        components:{
            // MoreHorizontal,
            // Delete
        },
        data() {
            return {
                show:false,
                dateFormat: 'D MMM',
                metricData:{
                    type:'custom',
                    startDate:'',
                    endDate:''
                },
                totalRows: 1,
                currentPage: 1,
                perPage: 5,
                pageOptions: [5, 10, 15, 20],
                sortBy: '',
                account: '',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                filterOn: [],
                infoModal: {
                    id: 'info-modal',
                    title: '',
                    content: ''
                },
            }
        },
        computed: {
            getAccounts() {
                // Create an options list from our fields

                return this.accounts;
            },
            ...mapState([
                'company',
                'logs',
                //'account'
            ]),
            metrics:{
                get(){
                    return this.logs.ftMetrics.type
                },
                set(val){
                    let metrics = {
                        type:'',
                        startDate:null,
                        endDate:null
                    };
                    console.log(val)
                    this.show = false;
                    let today = new Date();
                    if (val === 'today') {
                        metrics.type = 'today';
                        metrics.startDate = today.toJSON().slice(0,10);
                        metrics.endDate = new Date(new Date().setDate(today.getDate()+1)).toJSON().slice(0,10);
                    }else if (val === 'thisweek') {
                        let priorDate = this.getMonday(new Date());
                        metrics.type = 'thisweek';
                        metrics.startDate = priorDate.toJSON().slice(0,10);
                        metrics.endDate = new Date(new Date().setDate(today.getDate()+1)).toJSON().slice(0,10);
                    }else if (val === 'thismonth') {
                        let priorDate = new Date(today.getFullYear(), today.getMonth(), 2);
                        metrics.type = 'thismonth';
                        metrics.startDate = priorDate.toJSON().slice(0,10);
                        metrics.endDate = new Date(new Date().setDate(today.getDate()+1)).toJSON().slice(0,10);
                    }else if (val === 'last30') {
                        let priorDate = new Date(new Date().setDate(today.getDate()-30));
                        metrics.type = 'last30';
                        metrics.startDate = priorDate;//.toJSON().slice(0,10);
                        metrics.endDate = new Date(new Date().setDate(today.getDate()+1)).toJSON().slice(0,10);
                    }else if (val === 'last90') {
                        let priorDate = new Date(new Date().setDate(today.getDate()-90));
                        metrics.type = 'last90';
                        metrics.startDate = priorDate.toJSON().slice(0,10);
                        metrics.endDate = new Date(new Date().setDate(today.getDate()+1)).toJSON().slice(0,10);
                    }else if (val === 'thisyear') {
                        let priorDate = new Date(new Date().setDate(today.getDate()-30));
                        metrics.type = 'thisyear';
                        metrics.startDate = priorDate.toJSON().slice(0,10);
                        metrics.endDate = new Date(new Date().setDate(today.getDate()+1)).toJSON().slice(0,10);
                    }else if (val === 'alltime') {
                        metrics.type = 'alltime';
                        metrics.startDate = null;
                        metrics.endDate = null;
                    }
                    if (val !== 'custom' && this.type === 'ft') {
                        console.log('>>>>>>>con1')
                        this.$store.commit("logs/updateFtMetrics", metrics)
                        this.$store.commit("logs/updateFtLogs", [])
                        this.$store.dispatch("logs/readFtLogs", {
                            customerId: this.company.account[0].accCustID
                        })
                    }else if (val !== 'custom' && this.type === 'ne') {
                        console.log('>>>>>>>con2')
                        this.$store.commit("logs/updateNeMetrics", metrics)
                        this.$store.commit("logs/updateNeLogs", [])
                        this.$store.dispatch("logs/readNeLogs", {
                            customerId: this.company.account[0].accCustID
                        })
                    }else{
                        console.log('>>>>>>>con2',);
                        metrics.type = 'custom';
                        this.$store.commit("logs/updateFtMetrics", metrics);
                        this.show = true
                    }
                }
            }
        },
        mounted() {
            // Set the initial number of items
            this.totalRows = this.items.length
        },
        methods: {
            navigate(_id){
                localStorage.suOfficerID = _id;
                this.$router.push('/officer-details');
            },
            onFiltered(){

            },
            queryFt(){
                this.$store.commit("logs/updateFtMetrics", this.metricData);
                this.$store.commit("logs/updateFtLoading", true);
                this.$store.dispatch("logs/readFtLogs", {
                    customerId: this.company.account[0].accCustID
                })
            },
            getMonday(d) {
                d = new Date(d);
                let day = d.getDay(),
                    diff = d.getDate() - day + (day === 0 ? -6:1); // adjust when day is sunday
                return new Date(d.setDate(diff));
            },
            formatDates(dateOne, dateTwo) {
                let formattedDates = ''
                if (dateOne) {
                    formattedDates = format(dateOne, this.dateFormat)
                }
                if (dateTwo) {
                    formattedDates += ' - ' + format(dateTwo, this.dateFormat)
                }
                return formattedDates
            }
        }
    }
</script>
